import { OpaqueToken } from '@angular/core';
export var /** @type {?} */ DOCUMENT = new OpaqueToken('DOCUMENT');
/**
 * @return {?}
 */
export function _document() {
    return document;
}
//# sourceMappingURL=document.service.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-clipboard/dist/src/document.service.js
// module id = 697
// module chunks = 4